@if (loaded) {
  <div class="modal-content">
    <div class="modal-header bg-tertiary">
      <h6 class="modal-title fw-bold">Affiliate Users</h6>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Email</th>
              <th>Phone number</th>
              <th>Enabled</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (affiliateUser of affiliateUsers; track affiliateUser; let i = $index) {
              <tr>
                <td class="align-content-around">{{ affiliateUser.id }}</td>
                <td>
                  <input [(ngModel)]="affiliateUser.email" class="form-control" placeholder="Email" type="email"/>
                </td>
                <td>
                  <input [(ngModel)]="affiliateUser.phoneNumber" class="form-control" placeholder="Phone number" type="text"/>
                </td>
                <td>
                  <app-input-switch [(ngModel)]="affiliateUser.enabled" onLabel="Enabled" offLabel="Disabled"></app-input-switch>
                </td>
                <td class="text-end">
                  <button (click)="submit(affiliateUser)" [disabled]="!affiliateUser.email || submitting" class="btn btn-primary me-3" type="button">{{ affiliateUser.id ? 'Update' : 'Create' }}</button>
                  @if (affiliateUser.id) {
                    <button (click)="delete(i)" appConfirm class="btn btn-danger" type="button">Delete</button>
                  }
                  @if (!affiliateUser.id) {
                    <button (click)="affiliateUsers.splice(i, 1)" class="btn btn-danger" type="button">Delete</button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer bg-tertiary">
      <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>
      <button (click)="add()" type="button" class="btn btn-primary fw-bold"><i class="bi bi-plus-circle-fill me-2"></i>Add user</button>
    </div>
  </div>
}
